import React, { ChangeEvent } from 'react';

import { ValueBox, ValueGroup, ValueInput, ValueToggle } from '@candu-ai/craft/ui';
import { VariableHelp, VariableSummary } from 'craft/components/ToolboxVariable';
import { NavigateAction } from 'craft/types';

import { InteractionFieldProps } from './interactionFields';

export const NavigateField = ({
  collection,
  defaultValue,
  onChange,
}: InteractionFieldProps<NavigateAction['handler']>) => {
  const { href, target } = defaultValue || {};

  const onChangeHref = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    return onChange({
      ...defaultValue,
      href: value.trim(),
    });
  };
  const onChangeTarget = () =>
    onChange({ ...defaultValue, target: target === 'Blank' ? undefined : 'Blank' });

  return (
    <>
      <ValueGroup>
        {!collection && (
          <ValueBox isInGroup={{ isLast: true }}>
            <ValueInput
              placeholder="https://www.example.com"
              value={href}
              onChange={onChangeHref}
            />
          </ValueBox>
        )}
      </ValueGroup>

      {href ? <VariableSummary url={href} /> : null}
      <VariableHelp />

      <ValueGroup>
        <ValueBox label="Open in new tab">
          <ValueToggle
            toggleGroup="link-open-new-tab"
            isActive={target === 'Blank'}
            onClick={onChangeTarget}
            color={collection ? 'orange' : undefined}
          />
        </ValueBox>
      </ValueGroup>
    </>
  );
};
